import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { RuntimeConfigService } from 'src/app/config/runtime-config.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard implements CanActivate {
  constructor(
    private runtimeConfigService: RuntimeConfigService,
    private router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (!this.runtimeConfigService.maintenanceEnabled) {
      return this.router.parseUrl('/inventory');
    }
    return true;
  }
}
